module.exports = __webpack_public_path__ + "bf6d020f10bc9dcc11b159464442726f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Mission/images/img_mission_value02.svg
// module id = 1271
// module chunks = 7